<template>
    <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on }">
            <v-btn icon small class="grey--text" @click="renderGame(gameId)" v-on="on">
                <v-icon small color="blue-grey accten-4">mdi-trash-can-outline</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="ma-3">
                <h4 class="body-2 grey--text">
                    <v-icon class="blue-grey--text">mdi-playlist-remove</v-icon>
                    게임을 지울까요?
                </h4>
            </v-card-title>        
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn text small class="my-5 mx-auto blue-grey white--text" @click="deleteGame(gameId)">지우기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    
</template>

<script>
import slugify from 'slugify'
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    name: 'Confirm',
    props: [ 'gameId', 'groupId' ],
    data: () => ({
        dialog: false,
        game: '',
        user: null,
        userId: null,
        opponentId: null,
        playerOneId: null,
        playerTwoId: null
    }),
    created(){
        // get current user
        let user = firebase.auth().currentUser;

        // find the user record
        if(user){
            db.collection('users').where('user_id', '==', user.uid).get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        this.user = {
                            ...doc.data(),
                            id: doc.id
                        }
                    })
                })
        } else {
            return false
        }
    },
    methods: {
        renderGame(id){
            db.collection('games').doc(id).get().then(doc => {
                this.game = doc.data();
            }).then(() => {

                // find out the ids of both players
                this.playerOneId = slugify(this.game.playerOne.alias, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@]/g,
                    lower: true
                })
                this.playerTwoId = slugify(this.game.playerTwo.alias, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@]/g,
                    lower: true
                })

                if(this.playerOneId == this.user.id){
                    this.userId = this.playerOneId;
                    this.opponentId = this.playerTwoId;
                } else {
                    this.userId = this.playerTwoId;
                    this.opponentId = this.playerOneId;
                }
            })         
        },
        deleteGame(id){
            if(this.game.playerOne.result == null && this.game.playerTwo.result == null){
                // delete the game
                this.deleteAndUpdate(id)
            } else if(this.game.playerOne.result != null && this.game.playerTwo.result != null){
                return false
            } else {
                if(this.playerOneId == this.userId && this.game.playerOne.result != null){
                    // delete the game
                    this.deleteAndUpdate(id)
                } else if(this.playerOneId == this.userId && this.game.playerOne.result == null){
                    return false
                } else if(this.playerTwoId == this.userId && this.game.playerTwo.result != null){
                    // delete the game
                    this.deleteAndUpdate(id)
                } else if(this.playerTwoId == this.userId && this.game.playerTwo.result == null){
                    return false
                }
            }
            
        },
        deleteAndUpdate(id){
            db.collection("games").doc(id).delete().then(() => {
                this.dialog = false;
            }).then(() => {
                db.collection("users").doc(this.userId).update({
                    inGame: false
                })
                db.collection("users").doc(this.opponentId).update({
                    inGame: false
                })
            })  
        }        
    }
}
</script>

<style>

</style>